module.exports = __webpack_public_path__ + "balearic-islands.svg?b1bb64004f36989afbff664753cacd7d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/balearic-islands.svg
// module id = 103
// module chunks = 10